module.exports = __webpack_public_path__ + "img/arrow_desempenho_carteira_icon.3059201e.svg";